import { D as n } from "./dialog-ByNwXkEL.js";
import { d as i } from "./utilities-D-QcnR4L.js";
import "./component-B88NZlIm.js";
import "./events-CnaEWcY_.js";
class o extends n {
  requiredRefs = ["panels"];
  stack = ["menu-main"];
  connectedCallback() {
    (super.connectedCallback(), this.addEventListener("click", this.#s), this.#t());
  }
  #t() {
    this.refs.panels.querySelectorAll("[data-menu-panel]").forEach((t) => {
      t.id === "menu-main"
        ? t.setAttribute("data-state", "active")
        : t.setAttribute("data-state", "closed");
    });
  }
  #s = (e) => {
    const t = e.target.closest("[data-menu-target]");
    if (t) {
      e.preventDefault();
      const a = t.dataset.menuTarget;
      this.#a(a);
      return;
    }
    if (e.target.closest("[data-menu-back]")) {
      (e.preventDefault(), this.#n());
      return;
    }
  };
  #a(e) {
    const t = this.refs.panels.querySelector(`#${e}`);
    if (!t) {
      console.warn("Panel not found:", e);
      return;
    }
    (this.stack.push(e),
      this.#e(),
      setTimeout(() => {
        const s = t.querySelector("[data-menu-back], a, button");
        s && s.focus();
      }, 50));
  }
  #n() {
    if (this.stack.length <= 1) return;
    const e = this.stack[this.stack.length - 2],
      t = this.refs.panels.querySelector(`#${e}`);
    t &&
      (this.stack.pop(),
      this.#e(),
      setTimeout(() => {
        if (t) {
          const s = t.querySelector("button, a");
          s && s.focus();
        }
      }, 50));
  }
  #e() {
    const e = this.stack[this.stack.length - 1];
    this.refs.panels.querySelectorAll("[data-menu-panel]").forEach((s) => {
      const a = this.stack.indexOf(s.id);
      s.id === e
        ? s.setAttribute("data-state", "active")
        : a >= 0
          ? s.setAttribute("data-state", "behind")
          : s.setAttribute("data-state", "closed");
    });
  }
  closeDialog() {
    return super.closeDialog().then(() => {
      ((this.stack = ["menu-main"]), this.#t());
    });
  }
}
i("mobile-menu-component", o);
